export default "__VITE_ASSET__DBNQXPO5__"